<div class="login-modal-overlay" *ngIf="isVisible" (click)="onModalBackdropClick($event)">
  <div class="login-modal-content">
    <div class="modal-header">
      <h2>Admin Login</h2>
      <button class="close-btn" (click)="onClose()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="modal-body">
      <div *ngIf="errorMessage" class="error-message">
        <div class="error-text">{{ errorMessage }}</div>
        
        <!-- Show mock login button if API is not available -->
        <div *ngIf="errorMessage.includes('connect') || errorMessage.includes('HTML')" class="mock-login-section">
          <hr>
          <small><strong>Development Mode:</strong></small>
          <button mat-stroked-button 
                  (click)="username='admin'; password='admin123'"
                  class="mock-btn small-btn">
            Fill Admin Credentials
          </button>
          <button mat-stroked-button 
                  (click)="mockLogin()"
                  class="mock-btn small-btn">
            Mock Login
          </button>
        </div>
      </div>

      <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
        <div class="form-group">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Username</mat-label>
            <input matInput 
                   [(ngModel)]="username" 
                   name="username" 
                   required
                   autocomplete="username"
                   #usernameField="ngModel"
                   [disabled]="isLoading">
            <mat-error *ngIf="usernameField.invalid && usernameField.touched">
              Username is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-group">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Password</mat-label>
            <input matInput 
                   [type]="hidePassword ? 'password' : 'text'"
                   [(ngModel)]="password" 
                   name="password" 
                   required
                   autocomplete="current-password"
                   #passwordField="ngModel"
                   [disabled]="isLoading">
            <button mat-icon-button 
                    matSuffix 
                    (click)="hidePassword = !hidePassword"
                    type="button"
                    tabindex="-1"
                    [disabled]="isLoading">
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="passwordField.invalid && passwordField.touched">
              Password is required
            </mat-error>
          </mat-form-field>
        </div>

        <div class="form-actions">
          <button mat-button 
                  type="button" 
                  (click)="onClose()"
                  class="cancel-btn"
                  [disabled]="isLoading">
            Cancel
          </button>
          <button mat-raised-button 
                  color="primary" 
                  type="submit"
                  class="login-btn"
                  [disabled]="!loginForm.form.valid || isLoading">
            <span *ngIf="!isLoading">Login</span>
            <span *ngIf="isLoading" class="loading-spinner">
              <mat-spinner diameter="20"></mat-spinner>
              Logging in...
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
